import { css } from '@emotion/css';
import { DateWrap, maxTextLines} from 'Shared/frontend/Poster';
import { Match, Switch } from 'solid-js';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { useUrls } from 'Shared/UrlProvider';
import { OneAct } from 'Shared/frontend/eventPosters/overlapping/OneAct';
import { TwoActs as OverlappingTwoActs } from 'Shared/frontend/eventPosters/overlapping/TwoActs';
import { ThreeActs as OverlappingThreeActs } from 'Shared/frontend/eventPosters/overlapping/ThreeActs';
import { FourActs as OverlappingFourActs } from 'Shared/frontend/eventPosters/overlapping/FourActs';
import { TwoActs as SeparatedTwoActs } from 'Shared/frontend/eventPosters/separated/TwoActs';
import { ThreeActs as SeparatedThreeActs } from 'Shared/frontend/eventPosters/separated/ThreeActs';
import { FourActs as SeparatedFourActs } from 'Shared/frontend/eventPosters/separated/FourActs';

import { FiveActs } from 'Shared/frontend/eventPosters/FiveActs';


export const commonGenresStyle = () => css({
	textTransform: 'lowercase',
	lineHeight: 2,
	fontSize: '0.7em',
	...maxTextLines(2),

});

export function actImageUrl(image)
{
	if (!image?.hash)
		return '';
	return useUrls().createVenueImageUrl(image.hash,image,'Lineup-image','medium',useProxyProductionImages());
}


export function MusicPoster(P)
{
	const numActs = () => P.lineup?.length ?? 0;

	const sep = () => P.posterSettings.theme=='separated';

	return (
		<DateWrap {...P}>
			<Switch>
				<Match when={numActs() == 1}>
					<OneAct {...P} /> 
				</Match>
				<Match when={numActs() == 2}>
					{sep() ? <SeparatedTwoActs {...P} /> : <OverlappingTwoActs {...P} /> }
				</Match>
				<Match when={numActs() == 3}>
					{sep() ? <SeparatedThreeActs {...P} /> : <OverlappingThreeActs {...P} /> }
				</Match>
				<Match when={numActs() == 4}>
					{sep() ? <SeparatedFourActs {...P} /> : <OverlappingFourActs {...P} /> }
				</Match>
				<Match when={true}>
					<FiveActs {...P} />
				</Match>
			</Switch>
		</DateWrap>
	);
}

